import indexableDomains from '../../../indexable-domains.json';

export const JUSTGO_DOMAINS: string[] = [
  'justgo.co.za',
  'www.justgo.co.za',
  'justgo.quickbus.com',
  'justgo-dev.quickbus.com',
  'beta-dev.justgo.co.za',
  'localhost',
  'berelo-dev.justgo.co.za',
  'berelo.justgo.co.za',
  'moya-dev.justgo.co.za',
  'moya.justgo.co.za',
];

export const MTN_DOMAINS: string[] = [
  'mtn.quickbus.com',
  'mtn-dev.quickbus.com',
  'travelwisemtn.co.za',
  'www.travelwisemtn.co.za',
];

export const DIRECT_REWARDS_DOMAINS: string[] = [
  'directtravel.co.za',
  'www.directtravel.co.za',
  'directrewards-dev.quickbus.com',
  'directrewards.quickbus.com',
  'www.directrewards.quickbus.com',
  'localhost',
  'localhost:4200',
];

// Search-engine indexing allowlist. ONLY these hosts are allowed to be indexed;
// every other host (including all `*-dev.quickbus.com` and unlisted partner/country
// domains) gets a blanket `noindex, nofollow`. To let a new domain be indexed,
// add it to src/indexable-domains.json.
export const INDEXABLE_DOMAINS: string[] = indexableDomains;

// True when the current host is allowed to be indexed by search engines.
export function isIndexableDomain(): boolean {
  return INDEXABLE_DOMAINS.includes(window.location.hostname);
}

export function isJustGoDomain(): boolean {
  const hostname = window.location.hostname;
  return JUSTGO_DOMAINS.includes(hostname);
}

export function isMtnDomain(): boolean {
  const hostname = window.location.hostname;
  return MTN_DOMAINS.includes(hostname);
}

export function isDirectRewardsDomain(): boolean {
  const hostname = window.location.hostname;
  return DIRECT_REWARDS_DOMAINS.includes(hostname);
}
